import {Button, Modal, Spin} from 'antd'
import {report_createReport_Api} from 'apis'
import {codiDocumentSchema} from 'apis/schema'
import classNames from 'classnames'
import {SelectEntityItem} from 'components/SelectEntityItem'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {AppEntities} from 'views/AppLocals/enums'
import {notifyOnError} from 'views/AppLocals/factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from 'views/AppLocals/factory/createNotification'
import {NullAsDefault, renderElse} from 'views/Shared'
import ReportModal from './ReportModal'

export const ReportModalTitle = ({ title = 'report' }) => (
  <Translate>
    {(t) => (
      <div className="text-center font-bold text-color-000 uppercase tracking-wide">
        {t(title)}
      </div>
    )}
  </Translate>
)

const ReportButton = ({
  label,
  onSubmit,
  owner_id,
  owner_type,
  modal_header,
  toggle = NullAsDefault,
  onClick = NullAsDefault,
  isToggle = false,
  isLoading = false,
  ...props
}) => {
  const t = useTranslate()

  const onCancel = () => {
    toggle(false)
  }

  return (
    <React.Fragment>
      <Button
        size="small"
        type="primary"
        className="text-sm font-medium no-shadow no-text-shadow rounded-md px-4"
        onClick={() => {
          toggle(true)
          onClick()
        }}
        {...props}>
        {_.isString(label) ? t(label) : label}
      </Button>
      <Modal
        className="custom-modal"
        footer={null}
        open={isToggle}
        onCancel={onCancel}
        title={<ReportModalTitle />}
        destroyOnHidden={true}>
        <Spin spinning={!!isLoading}>
          <ReportModal
            onSubmit={onSubmit}
            onCancel={onCancel}
            owner_id={owner_id}
            header={modal_header}
            owner_type={owner_type}
          />
        </Spin>
      </Modal>
    </React.Fragment>
  )
}

export const CodiReportButton = ({
  id,
  style,
  className,
  label = 'report',
  Component = ReportButton,
  withProps = (props) => ({}),
  type = AppEntities.CODI_DOCUMENT,
}) => {
  const t = useTranslate()

  const [isToggle, toggle] = useState(false)

  const { isLoading, handleAsyncAction } = useAsyncAction({
    apiInfo: report_createReport_Api,
    onError: notifyOnError(t),
    onSuccess: () => {
      successNotify(NotificationActionTypes.CREATE, t)
      toggle(false)
    },
  })

  const header = useMemo(
    () => (
      <SelectEntityItem
        item={id}
        schema={codiDocumentSchema}>
        {(item) => {
          return renderElse(
            _.isEmpty(item),
            <div className="flex flex-col italic border rounded-lg p-2">
              <span className="font-light text-xs text-color-400">
                {t('document')}
              </span>
              <span className="font-bold text-lg text-primary ml-2">
                {getTitle(item)}
              </span>
            </div>
          )
        }}
      </SelectEntityItem>
    ),
    [id, type]
  )
  return (
    <div className="flex flex-col gap-2">
      <div
        style={style}
        className={classNames('flex flex-1 justify-end', className)}>
        <Component
          label={label}
          owner_id={id}
          toggle={toggle}
          owner_type={type}
          isToggle={isToggle}
          modal_header={header}
          isLoading={isLoading}
          onSubmit={(values) => {
            handleAsyncAction(values)
          }}
          {...(withProps({ id, type }) ?? {})}
        />
      </div>
    </div>
  )
}

export default ReportButton
